<template>
  <card>
    <b-row align-v="center" slot="header">
      <b-col cols="8">
        <h3 class="mb-0">Google Link Review</h3>
      </b-col>
    </b-row>

    <b-form @submit.prevent="updateData">
      <div class="pl-lg-4">
        <b-row>
          <b-col lg="12">
            <base-input
              type="text"
              label="Review Link"
              placeholder="Review Link"
              v-model="form.review_link"
            ></base-input>
          </b-col>
        </b-row>
      </div>

      <hr class="my-4" />
      <div class="text-right">
        <base-button type="primary" @click="updateData()">Save</base-button>
      </div>
    </b-form>
  </card>
</template>
<script>
// import BaseSlider from '@/components/BaseSlider'
import { services, getHeader } from "@/assets/js/config.js";
import axios from "axios";
import notifyFunctionMixin from "@/assets/js/notifyFunctionMixin.js";
import { mapActions, mapState } from "pinia";
import { useAuthStore } from "@/stores/authStore";
import { helperFunctionMixin } from "@/assets/js/httpImports.js";

export default {
  name: "review_link",
  mixins: [notifyFunctionMixin, helperFunctionMixin],
  data() {
    return {
      form: {
        review_link: "",
      },
    };
  },
  async created() {
    await this.fetchExistingData();
  },
  computed: {
    ...mapState(useAuthStore, ["auth_user"]),
  },
  methods: {
    async fetchExistingData() {
        try {
        const corporateId = this.auth_user.account_info.corporate_id;
        const existingData = await axios.get(
            services.access_control + "corporate/" + corporateId,
            { headers: getHeader() }
        );
        
        if (existingData.data.data.review_link) {
            this.form.review_link = existingData.data.data.review_link;
        }
        } catch (e) {
        console.error("Failed to fetch existing data:", e.response.data.message);
        }
    },
    async updateData() {
      try {
        const corporateId = this.auth_user.account_info.corporate_id;

        const existingData = await axios.get(
          services.access_control + "corporate/" + corporateId,
          { headers: getHeader() }
        );
   
        const updatePayload = {
          ...existingData.data.data, 
          review_link: this.form.review_link,
        };

        const res = await axios.put(
          services.access_control + "corporate/" + corporateId,
          updatePayload,
          { headers: getHeader() }
        );

        this.corporateDetail = res.data.data;
        console.log("Corporate details updated:", this.corporateDetail);

        this.notifySuccess("Corporate details updated successfully.");
      } catch (e) {
        this.corporateDetail = {};
        console.error(
          "Update corporate details failed:",
          e.response.data.message
        );
        this.notifyError("Failed to update corporate details.");
      }
    },
  },
};
</script>
<style></style>
